
import PayrollOverview from "./payroll-overview";
import MyPayslips from "./my-payslips";
import MyLoans from "./my-loans";
import { useEffect, useState } from "react";
import Reimbursements from "./my-reimbursements";
import ArrearsAndIncentives from "./my-incentives";
import TaxTab from "./my-tax";



export const PayrollHeader = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [masked, setMasked] = useState(true);

  const toggleMask = () => {
    console.log("Toggling mask. Currently masked =", masked);
    setMasked(!masked);
  };

  useEffect(() => {
    showTab();
  }, [activeTab]);

  const showTab = () => {

    switch (activeTab) {
      case "overview":
        return <PayrollOverview hideAmount={masked} />;
      case "payslips":
        return <MyPayslips hideAmount={masked} />;
      case "loans":
        return <MyLoans hideAmount={masked} />;
      case "reimb":
        return <Reimbursements hideAmount={masked} />;
      case "arrears":
        return <ArrearsAndIncentives hideAmount={masked} />;
      case "tax":
        return <TaxTab hideAmount={masked} />;
      default:
        return null;
    }

  };

  return (
    <div className="container-fluid">
      {/* Top Nav */}
      <div className="form-head d-flex flex-wrap align-items-center page-head">
        <div className="me-auto">
          <h2 className="font-w600 mb-0">Payroll Dashboard</h2>
        </div>
        <div className="rightside-tabs">
          <div className="emp-nav-right">
            <span style={{ fontSize: '12px', color: 'rgb(155 145 179)' }}>
              BizBrolly Solutions Pvt. Ltd.
            </span>

            <button
              onClick={toggleMask}
              title="Show/hide salary amounts"
              style={{
                background: 'rgb(135 135 135)',
                border: '1px solid rgba(255,255,255,.2)',
                borderRadius: '8px',
                color: 'rgb(255 255 255)',
                padding: '6px 12px',
                fontSize: '11px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
              }}
            >
              <i className={`fa-regular ${masked ? 'fa-eye-slash' : 'fa-eye'}`} />
              <span>{masked ? 'Show Amounts' : 'Hide Amounts'}</span>
            </button>
          </div>
        </div>
      </div>
      {/* Tab Bar */}
      <nav className="tab-bar">
        <button
          className={`tab-btn ${activeTab === 'overview' ? 'active' : ''}`}
          onClick={() => setActiveTab('overview')}
        >
          <i className="fa-solid fa-gauge-high" /> Overview
        </button>
        <button
          className={`tab-btn ${activeTab === 'payslips' ? 'active' : ''}`}
          onClick={() => setActiveTab('payslips')}
        >
          <i className="fa-regular fa-file-lines" /> My Payslips
        </button>
        <button
          className={`tab-btn ${activeTab === 'loans' ? 'active' : ''}`}
          onClick={() => setActiveTab('loans')}
        >
          <i className="fa-solid fa-hand-holding-dollar" /> Loans &amp; Advances
        </button>
        <button
          className={`tab-btn ${activeTab === 'reimb' ? 'active' : ''}`}
          onClick={() => setActiveTab('reimb')}
        >
          <i className="fa-solid fa-receipt" /> Reimbursements
        </button>
        <button
          className={`tab-btn ${activeTab === 'arrears' ? 'active' : ''}`}
          onClick={() => setActiveTab('arrears')}
        >
          <i className="fa-solid fa-rotate-left" /> Arrears &amp; Incentives
        </button>
        <button
          className={`tab-btn ${activeTab === 'tax' ? 'active' : ''}`}
          onClick={() => setActiveTab('tax')}
        >
          <i className="fa-solid fa-file-invoice-dollar" /> Tax &amp; TDS
        </button>
      </nav>

      {/* Tab Contents */}
      <div className="tab-content">
        {showTab(activeTab)}
      </div>
    </div>
  )
}

export default PayrollHeader;
